// PROPOSITO: entrada de la app. Arranca la sesion, escucha la red y monta el router.
// DEPENDENCIAS: react-dom/client, router, servicios de sesion y sincronizacion.
// NO OBVIO: el estilo entra ANTES del primer render para que no haya parpadeo de tema, y la
// escucha de red se instala antes de montar para que una alumna que abre la app sin senal ya vea
// la barra correcta en el primer pintado.

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import '@/styles/global.css'
import { router } from '@/router'
import { arrancarSesion } from '@/services/sesion.service'
import { escucharLaRed } from '@/services/sincronizacion.service'
import { leerTemaGuardado, pintarTema } from '@/lib/tema'

// Cinturon: /tema.js ya lo hizo antes del primer pintado. Si ese archivo no llegara —cache raro,
// red a medias, una CSP mas estricta manana— el tema elegido se aplicaria igual aqui, un instante
// mas tarde. Aplicar dos veces el mismo valor no cuesta nada; no aplicarlo ninguna, si.
pintarTema(leerTemaGuardado())

escucharLaRed()
void arrancarSesion()

const raiz = document.getElementById('root')
if (!raiz) throw new Error('No existe el elemento #root en index.html')

createRoot(raiz).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
